// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom_footer_sticky[data-v-b81881ae]{position:fixed;bottom:0;left:0}.custom-height[data-v-b81881ae]{height:calc(100vh - 48px)}.custom_dialog[data-v-b81881ae]{box-shadow:unset!important;overflow:unset!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
